import { useSettings } from "@/hooks/use-settings";
import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";
import { Shield } from "lucide-react";
import { Link } from "react-router";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { GoalsSection } from "./goals-section";
import { PreferencesSection } from "./preferences-section";
import { NotificationsSection } from "./notifications-section";
import { StationsSection } from "./stations-section";
import { DataSection } from "./data-section";
import { AccountSection } from "./account-section";
import { LegalSection } from "./legal-section";
import { EmailSection } from "./email-section";

export function SettingsPage() {
  const { settings, isLoading } = useSettings();
  const isAdmin = useQuery(api.admin.isAdmin);

  return (
    <div className="container mx-auto px-4 py-8 max-w-2xl pb-24">
      {isLoading ? (
        <SettingsPageSkeleton />
      ) : settings ? (
        <Tabs defaultValue="goals" className="w-full">
          <TabsList className="w-full grid grid-cols-4 mb-6">
            <TabsTrigger value="goals">Goals</TabsTrigger>
            <TabsTrigger value="preferences">Prefs</TabsTrigger>
            <TabsTrigger value="stations">Stations</TabsTrigger>
            <TabsTrigger value="account">Account</TabsTrigger>
          </TabsList>

          <TabsContent value="goals" className="space-y-6">
            <GoalsSection settings={settings} />
          </TabsContent>

          <TabsContent value="preferences" className="space-y-6">
            <PreferencesSection settings={settings} />
            <NotificationsSection settings={settings} />
          </TabsContent>

          <TabsContent value="stations" className="space-y-6">
            <StationsSection settings={settings} />
          </TabsContent>

          <TabsContent value="account" className="space-y-6">
            <EmailSection />
            <DataSection />
            <LegalSection />
            <AccountSection />
            {isAdmin && (
              <Card>
                <CardContent className="pt-6">
                  <Link to="/admin">
                    <Button variant="outline" className="w-full">
                      <Shield className="h-4 w-4 mr-2" />
                      Admin Panel
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            )}
          </TabsContent>
        </Tabs>
      ) : (
        <div className="text-center text-muted-foreground py-8">
          Unable to load settings
        </div>
      )}
    </div>
  );
}

function SettingsPageSkeleton() {
  return (
    <div className="space-y-6">
      <Skeleton className="h-10 w-full" />
      {[1, 2].map((i) => (
        <Card key={i}>
          <CardHeader>
            <Skeleton className="h-6 w-32" />
            <Skeleton className="h-4 w-48" />
          </CardHeader>
          <CardContent className="space-y-4">
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-10 w-full" />
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
